import { DashboardConstants } from '../../actions/constant';

const {
 GET_DSN_SUMMARY_REQUEST,
  GET_DSN_SUMMARY_SUCCESS,
  GET_DSN_SUMMARY_FAILURE,
  GET_DSN_SUMMARY_LOADING,
  GET_DSN_SUMMARY_RESET,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isSuccess: false,
  loading: false,
};

export const getDsnSummaryReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_DSN_SUMMARY_SUCCESS: {
      return {
        ...state,
        isSuccess: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case GET_DSN_SUMMARY_FAILURE:
      return {
        ...state,
        isSuccess: false,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_DSN_SUMMARY_LOADING:
      return {
        ...state,
        loading: true,
      };

      case GET_DSN_SUMMARY_RESET:
        return intitialstate

    default:
      return state;
  }
};
